import React, { useEffect, useState } from 'react';
import { filter, find } from 'ramda';
import styled from 'styled-components';
import UserTournamentRegistry from './UserTournamentRegistry';
import { useQuery } from '~~utils/CommonUtils';
import Loading from '~~elements/Loading';
import toast from '~~elements/Toast';
import { TeamInSeasonRegistryResource } from '~~apis/resource';
import { RegistryProvider } from './useUserTournamentRegistry';
import UTRMultilingual from './Multilingual';

const StyledDiv = styled.div`
  padding: 3rem 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
`;

const Index = () => {
  const query = useQuery();
  const registryUniqid = query.get('registry');
  const teamInRegistryUniqid = query.get('team');

  const [list, setList] = useState(null);
  const [registryList, setRegistryList] = useState([]);

  const [loading, setLoading] = useState(false);
  const [teamInRegistry, setTeamInRegistry] = useState(null);
  const [registry, setRegistry] = useState(null);

  useEffect(() => {
    TeamInSeasonRegistryResource.getLoginUserTeamsInSeasonRegistries()
      .then(({ data }) => {
        data.sort((a, b) => {
          return new Date(b.last_updated_at).getTime() - new Date(a.last_updated_at).getTime();
        });
        setList(data);
      })
      .catch((e) => {
        toast(UTRMultilingual(`COMMON.UNKNOWN_ERROR`), { status: 'error' });
      });
  }, []);

  useEffect(() => {
    if (!list || !registryUniqid) {
      setRegistryList([]);
      return;
    }

    const registryList = filter((tir) => tir.registry_uniqid === registryUniqid, list);
    setRegistryList(registryList);
  }, [list, registryUniqid]);

  useEffect(() => {
    setTeamInRegistry(null);
    setRegistry(null);
    if (!teamInRegistryUniqid) {
      return;
    }

    const teamInRegistry = find(
      (tir) => tir.uniqid === teamInRegistryUniqid && tir.registry_uniqid === registryUniqid,
      registryList,
    );
    if (!teamInRegistry) {
      return;
    }

    setLoading(true);
    TeamInSeasonRegistryResource.getSeasonRegistry({ registryUniqid })
      .then(({ data }) => {
        setTeamInRegistry(teamInRegistry);
        setRegistry(data);
      })
      .catch((e) => {
        toast(UTRMultilingual(`COMMON.UNKNOWN_ERROR`), { status: 'error' });
      })
      .finally(() => {
        setLoading(false);
      });
  }, [registryList, registryUniqid, teamInRegistryUniqid]);

  if (list === null || loading) {
    return (
      <StyledDiv>
        <Loading width="20vw" />
      </StyledDiv>
    );
  }

  return (
    <RegistryProvider>
      <UserTournamentRegistry
        list={list}
        registryList={registryList}
        teamInRegistry={teamInRegistry}
        registry={registry}
      />
    </RegistryProvider>
  );
};

export default Index;
